export default {"src":"/_next/static/media/pebbleColour.4a401821.svg","height":498,"width":1245,"blurWidth":0,"blurHeight":0};